/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fixture_EditInputs */

const th_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนกำหนดการ`)
};

const en_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reschedule`)
};

const ja_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日程を変更`)
};

const zh_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新安排`)
};

const es_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprogramar`)
};

const pt_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remarcar`)
};

const id_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadwalkan ulang`)
};

const fr_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprogrammer`)
};

const tl_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muling iskedyul`)
};

const vi_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xếp lại lịch`)
};

const ko_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일정 변경`)
};

const de_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu ansetzen`)
};

const ru_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перенести`)
};

const tr_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden planla`)
};

const it_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprogramma`)
};

const pl_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przełóż`)
};

const uk_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перенести`)
};

const hi_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिर से निर्धारित करें`)
};

const ar_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة الجدولة`)
};

const ms_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadual semula`)
};

const bn_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সময় বদলান`)
};

const zh_tw2_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新安排`)
};

const zh_hk2_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新安排`)
};

const ur_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وقت بدلیں`)
};

const fa_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زمان‌بندی دوباره`)
};

const sw_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panga upya`)
};

const nl_fixture_edit = /** @type {(inputs: Fixture_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw inplannen`)
};

/**
* | output |
* | --- |
* | "Reschedule" |
*
* @param {Fixture_EditInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const fixture_edit = /** @type {((inputs?: Fixture_EditInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fixture_EditInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_fixture_edit(inputs)
	if (locale === "ja") return ja_fixture_edit(inputs)
	if (locale === "zh") return zh_fixture_edit(inputs)
	if (locale === "es") return es_fixture_edit(inputs)
	if (locale === "pt") return pt_fixture_edit(inputs)
	if (locale === "id") return id_fixture_edit(inputs)
	if (locale === "fr") return fr_fixture_edit(inputs)
	if (locale === "tl") return tl_fixture_edit(inputs)
	if (locale === "vi") return vi_fixture_edit(inputs)
	if (locale === "ko") return ko_fixture_edit(inputs)
	if (locale === "de") return de_fixture_edit(inputs)
	if (locale === "ru") return ru_fixture_edit(inputs)
	if (locale === "tr") return tr_fixture_edit(inputs)
	if (locale === "it") return it_fixture_edit(inputs)
	if (locale === "pl") return pl_fixture_edit(inputs)
	if (locale === "uk") return uk_fixture_edit(inputs)
	if (locale === "hi") return hi_fixture_edit(inputs)
	if (locale === "ar") return ar_fixture_edit(inputs)
	if (locale === "ms") return ms_fixture_edit(inputs)
	if (locale === "bn") return bn_fixture_edit(inputs)
	if (locale === "zh-TW") return zh_tw2_fixture_edit(inputs)
	if (locale === "zh-HK") return zh_hk2_fixture_edit(inputs)
	if (locale === "ur") return ur_fixture_edit(inputs)
	if (locale === "fa") return fa_fixture_edit(inputs)
	if (locale === "sw") return sw_fixture_edit(inputs)
	if (locale === "nl") return nl_fixture_edit(inputs)
	return en_fixture_edit(inputs)
});